import { memo } from 'react';
import { cn } from '../../helpers/util';

const style = 'h-2 w-2 rounded-full bg-muted-foreground';

interface LoadingControlsProps {
  className?: string;
}

const LoadingControls = ({ className }: LoadingControlsProps) => {
  return (
    <div
      data-cy="loading-controls"
      className={cn('pointer-events-none flex items-center justify-center space-x-1', className)}
    >
      <span className={cn('animate-pulse', style)} />
      <span className={cn('animate-pulse-short', style)} />
      <span className={cn('animate-pulse-long', style)} />
    </div>
  );
};

export default memo(LoadingControls);
